import { useState } from 'react';
import { Hello, Photobis, Avatar } from '../../CustomIcon';
import ModalBasic from '../../Modal/Basic';
import Heading from '../../Typography/Heading';
import Paragraph from '../../Typography/Paragraph';
import CardBig from '../../Card/Big';
import { useController } from 'react-hook-form';
import { Camera, Check, Loader } from 'react-feather';
import Button from '../../Button';
import Avatar1 from '../../../../../images/avatars/avatar1.svg';
import Avatar2 from '../../../../../images/avatars/avatar2.svg';
import Avatar3 from '../../../../../images/avatars/avatar3.svg';
import Avatar4 from '../../../../../images/avatars/avatar4.svg';
import classNames from 'classnames';
import Error from '../Error';
var defaultAvatars = [
    {
        id: '1',
        src: Avatar1,
    },
    {
        id: '2',
        src: Avatar2,
    },
    {
        id: '3',
        src: Avatar3,
    },
    {
        id: '4',
        src: Avatar4,
    },
];
var AvatarInput = function (_a) {
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, submit = _a.submit, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.border, border = _c === void 0 ? false : _c;
    var _d = useController({ name: name, control: control, defaultValue: defaultValue }), field = _d.field, fieldState = _d.fieldState;
    var _e = useState(false), modal = _e[0], setModal = _e[1];
    var _f = useState(false), showAvatars = _f[0], setShowAvatars = _f[1];
    var _g = useState(defaultAvatars[0]), defaultAvatar = _g[0], setDefaultAvatar = _g[1];
    var handleModalClose = function () {
        setModal(false);
        setShowAvatars(false);
    };
    var handleChange = function (e) {
        if (e.target.files[0].size > 5e6)
            return alert('Le poids du fichier ne doit pas dépasser 5Mo');
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function () {
            field.onChange(reader.result);
            submit && submit();
            if (!submit)
                handleModalClose();
        };
    };
    var toDataURL = function (url) {
        return fetch(url)
            .then(function (response) { return response.blob(); })
            .then(function (blob) {
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onloadend = function () { return resolve(reader.result); };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        });
    };
    var validateAvatar = function () {
        toDataURL(defaultAvatar.src).then(function (dataUrl) {
            field.onChange(dataUrl);
            submit && submit();
            if (!submit)
                handleModalClose();
        });
    };
    return (<>
      <div className="relative cursor-pointer self-center" onClick={function () { return setModal(true); }}>
        <div className="flex flex-col items-center">
          <div className={classNames('flex-center relative h-20 w-20 overflow-hidden rounded-full bg-gray-300', border && 'border-[3px] border-white')}>
            {field.value ? (<img className="cover-full" src={field.value} alt="avatar"/>) : (<Photobis size={44} className="fill-white"/>)}
          </div>
          {field.value && (<div className="flex-center absolute bottom-0 right-0 h-8 w-8 rounded-full bg-secondary-04">
              <Camera size={16} className="text-brand-01"/>
            </div>)}
          {fieldState.error && <Error message={fieldState.error.message}/>}
        </div>
      </div>
      <ModalBasic handleClose={handleModalClose} open={modal}>
        {loading && (<div className="absolute-full flex items-center justify-center rounded-2xl bg-brand-01 bg-opacity-30">
            <Loader size={30} className="animate-spin-loader text-white"/>
          </div>)}
        <div className="flex flex-col items-center max-md:pb-6">
          {showAvatars ? (<>
              <Heading level={3} type="h5">
                Choisir un avatar
              </Heading>
              <Paragraph size="sm" className="mt-6 text-center">
                Pas envie de vous afficher ? Sélectionnez un avatar :
              </Paragraph>
              <div className="mt-6 grid w-full grid-cols-2 gap-6 md:w-3/4">
                {defaultAvatars.map(function (avatar) { return (<div key={avatar.id} className={classNames('relative aspect-square cursor-pointer ring-[3px] ring-inset ring-transparent transition-all', avatar === defaultAvatar && 'ring-secondary-04')} onClick={function () { return setDefaultAvatar(avatar); }}>
                    {avatar === defaultAvatar && (<div className="flex-center absolute top-0 right-0 h-7 w-7 bg-secondary-04">
                        <Check size={16} className="text-white"/>
                      </div>)}
                    <img src={avatar.src} alt="Avatar" className="cover-full -z-1"/>
                  </div>); })}
              </div>
              <label className="mt-6 flex w-full cursor-pointer items-center gap-4 rounded-lg bg-gray-200 p-4 md:w-3/4">
                <input type="file" accept="image/png, image/jpeg, image/jpg" className="hidden" onChange={handleChange} name={name} defaultValue={defaultValue}/>
                <div className="flex-center h-12 w-12 flex-shrink-0 rounded-full bg-brand-01">
                  <Hello className="fill-white" size={32}/>
                </div>
                <Paragraph size="xs">
                  Pour améliorer votre visibilité sur l'annuaire,{' '}
                  <span className="font-medium underline">ajoutez une photo</span> de votre plus
                  beau profil.
                </Paragraph>
              </label>
              <Button className="mt-8 w-full md:w-3/4" onClick={validateAvatar}>
                {submit ? 'Sauvegarder' : 'Continuer'}
              </Button>
            </>) : (<>
              <Heading level={3} type="h5">
                Votre photo de profil
              </Heading>
              <Paragraph size="sm" className="mt-6 text-center">
                Ajoutez votre propre photo permet de vous reconnaître et de mieux mémoriser votre
                profil.
              </Paragraph>
              <div className="mt-10 flex flex-col gap-4">
                <label>
                  <input type="file" accept="image/png, image/jpeg, image/jpg" className="hidden" onChange={handleChange} name={name} defaultValue={defaultValue}/>
                  <CardBig title="Ajouter une photo" description="C’est le moment de présenter votre plus beau profil !" icon={Photobis}/>
                </label>
                <CardBig title="Choisir un avatar" description="Pas envie de vous afficher ? Sélectionnez un avatar." icon={Avatar} onClick={function () { return setShowAvatars(true); }}/>
              </div>
            </>)}
        </div>
      </ModalBasic>
    </>);
};
export default AvatarInput;
